import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import useGetComponentTypeIdByVariant from '../../hooks/component-types/useGetComponentTypeIdByVariant';
import useLabelsQuery from '../../hooks/labels/useLabelsQuery';

import { LabelModel, ParsedLabelsType } from '../../models/label.model';

const BannerForAlternates = ({
    suggestedLabels,
}: {
    suggestedLabels: ParsedLabelsType;
}) => {
    const componentTypeIdOne = useGetComponentTypeIdByVariant(
        suggestedLabels[0]?.type!,
    );

    const { data: variantOneMasterLabels } = useLabelsQuery(
        componentTypeIdOne as string,
    );

    const componentTypeIdTwo = useGetComponentTypeIdByVariant(
        suggestedLabels[1]?.type!,
    );

    const { data: variantTwoMasterLabels } = useLabelsQuery(
        componentTypeIdTwo as string,
    );
    // Early return if no suggested labels
    if (!suggestedLabels || suggestedLabels.length === 0) return null;

    /**
     * Filters the master label list by selected IDs.
     * @param masterLabels List of all possible labels for a variant type.
     * @param selectedIds Array of label IDs to filter for.
     * @returns Array of label names that match the selected IDs.
     */
    const getSelectedLabelNames = (
        masterLabels: LabelModel[],
        selectedIds: string[],
    ): string[] => {
        return masterLabels.reduce<string[]>((acc, label) => {
            if (selectedIds.includes(label.id.toString())) {
                acc.push(label.label_name);
            }
            return acc;
        }, []);
    };

    // Get label names for each variant
    const variantOneLabels = suggestedLabels[0]?.ids
        ? getSelectedLabelNames(
              variantOneMasterLabels ?? [],
              suggestedLabels[0].ids,
          )
        : [];

    const variantTwoLabels = suggestedLabels[1]?.ids
        ? getSelectedLabelNames(
              variantTwoMasterLabels ?? [],
              suggestedLabels[1].ids,
          )
        : [];
    return (
        <NormalText>
            You started this flow for using labels{' '}
            <BoldText>{variantOneLabels?.join(', ')}</BoldText> (
            {suggestedLabels[0]?.type}) and{' '}
            <BoldText>{variantTwoLabels?.join(', ')}</BoldText> (
            {suggestedLabels[1]?.type}) in the same message.
        </NormalText>
    );
};

const BoldText = styled.span({
    fontWeight: aampeTheme.weights.medium,
});
const NormalText = styled.span({
    padding: aampeTheme.spacing4(2, 4),
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.light,
    lineHeight: aampeTheme.size.lineHeight.textSmall,
});

export default BannerForAlternates;
